import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { BASE_URL } from '../apiConfig'

export const fetchAllBA = createAsyncThunk(
  'fetchAllBA',
  async ({ jwtBearer, ba_code, branch }) => {
    const response = await fetch(`${BASE_URL}ba/get/all/data/?ba_code=${ba_code}&branch=${branch}`, {
      headers: {
        Authorization: `Bearer ${jwtBearer}` // Include the bearer token in the request header
      }
    })
    return response.json()
  }
)

const fetchAllBASlice = createSlice({
  name: 'fetchAllBASlice',
  initialState: {
    isLoading: false,
    data: null,
    isError: false
  },
  extraReducers: builder => {
    builder.addCase(fetchAllBA.pending, (state, action) => {
      state.isLoading = true
    })
    builder.addCase(fetchAllBA.fulfilled, (state, action) => {
      state.isLoading = false
      state.data = action.payload
    })
    builder.addCase(fetchAllBA.rejected, (state, action) => {
      console.log('Error', action.payload)
      state.isError = true
    })
  }
})

export default fetchAllBASlice.reducer
